module.exports = __webpack_public_path__ + "img/scanqr.9f0e1733.png";